import React from 'react';
import classNames from 'classnames';
import _ from 'underscore';

interface Option {
  label: string;
  value: any;
}

interface ButtonsSelectProps {
  value: any;
  onChange?: (value: any) => void;
  options: Option[];
  emptyLabel?: string;
  multiple?: boolean;
}

const ButtonsSelect = ({ value, onChange, options, emptyLabel, multiple }: ButtonsSelectProps) => {
  const keysWithValue = (val) =>
    _.object(
      _.pluck(options, 'value'),
      options.map(() => val),
    );

  const onSelectAll = () => {
    if (multiple) {
      const val = { ...value, ...keysWithValue(true) };
      onChange(val);
      return;
    }

    onChange('');
  };

  const onSelect = (option) => {
    if (multiple) {
      const allDisabled = keysWithValue(false);
      let updated = allSelected()
        ? { ...value, ...allDisabled, [option.value]: true }
        : { ...value, [option.value]: !value[option.value] };

      if (_.every(options, (item) => !updated[item.value])) {
        updated = { ...value, ...keysWithValue(true) };
      }

      onChange(updated);
      return;
    }

    onChange(option.value);
  };

  const allSelected = () => {
    if (multiple) {
      return _.every(options, (option) => value[option.value]);
    }

    return ['', undefined, null].indexOf(value) >= 0;
  };

  return (
    <div className="buttons-select">
      {emptyLabel ? (
        <button
          type="button"
          className={classNames({ active: allSelected() })}
          onClick={onSelectAll}
        >
          {emptyLabel}
        </button>
      ) : null}

      {options.map((option, index) => (
        <button
          type="button"
          key={index}
          className={classNames({
            active: multiple ? !allSelected() && value[option.value] : value === option.value,
          })}
          onClick={() => onSelect(option)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ButtonsSelect;
